import { useLocation } from "react-router-dom";

export const useLocationState = <T extends object>(): T => {
	const location = useLocation();

	return (location.state ?? {}) as T;
};
